import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Product item type
export interface VehicleData {
  id: string;
  [key: string]: any;
}

// API response shape
interface FleetListResponse {
  vehicleData: VehicleData[];
  total: number;
  page: number;
  totalPages: number;
}

// Slice state
interface PromoState {
  data: FleetListResponse | null;
  loading: boolean;
  error: string | null;
}

// Update payload
export interface FleetUpdatePayload {
  id: string;
  [key: string]: any;
}

const initialState: PromoState = {
  data: null,
  loading: false,
  error: null,
};

const fleetSlice = createSlice({
  name: "fleet",
  initialState,
  reducers: {
    // setFleetList(state, action: PayloadAction<FleetListResponse>) {
    //   state.data = action.payload;
    //   state.loading = false;
    //   state.error = null;
    // },
    setFleetList(state, action: PayloadAction<FleetListResponse>) {
  state.data = {
    ...action.payload,
    vehicleData: action.payload.vehicleData || [], // ensure array
  };
  state.loading = false;
  state.error = null;
},

addFleet(state, action: PayloadAction<VehicleData>) {
  const newFleet = action.payload;

  if (state.data) {
    if (!state.data.vehicleData) {
      state.data.vehicleData = [];
    }
    state?.data?.vehicleData?.unshift(newFleet);
    state.data.total += 1;

    if (state.data.vehicleData.length > 10) {
      state?.data?.vehicleData?.pop();
    }
  } else {
    state.data = {
      vehicleData: [newFleet],
      total: 1,
      page: 1,
      totalPages: 1,
    };
  }
},
    fleetUpdate(state, action: PayloadAction<FleetUpdatePayload>) {
      const { id, ...updates } = action.payload;
      if (!state.data?.vehicleData) return;

      const fleet = state.data.vehicleData.find((p) => p.id === id);
      if (fleet) {
        Object.assign(fleet, updates);
      }
    },

    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

export const {
  setFleetList,
  addFleet,
  fleetUpdate,
  setLoading,
  setError,
} = fleetSlice.actions;

export default fleetSlice.reducer;
